module.exports = __webpack_public_path__ + "static/media/model-patrol-97-lwb.9ca02e8a.jpg";